import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateProgramTabsWrapper = styled.div`
  margin-top: 32px;
  .MuiGrid2-root {
    padding-right: 16px;

    ${responsive.MOBILE`
      padding-right: 0px;
    `}
  }

  .MuiTabs-flexContainer {
    border-bottom: 5px solid ${COLORS.cirrus_black3};
  }

  .program-detail {
    padding: 0px 16px 24px 16px;

    ${responsive.MOBILE`
      padding: 0px 8px 16px 8px;
    `}
  }

  .header-collapse {
    margin: 16px 16px 16px 16px;
    text-align: end;
  }
  .accordion-header {
    margin: 26px 0px;
  }
  .status-label {
    margin: 24px 16px 24px 16px;

    ${responsive.MOBILE`
      margin: 16px 8px 16px 8px;
    `}
  }

  .active-change-status {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .participant-tab {
    .header-collapse {
      margin-bottom: 0;
    }

    .MuiPickersTextField-root,
    .MuiPickersInputBase-root {
      width: 100%;
    }

    .participant-accordion {
      margin-top: 16px;
      margin-bottom: 32px;

      ${responsive.MOBILE`
        margin-bottom: 16px;
      `}
    }
    .participant-accordion:last-child {
      margin-bottom: 16px;
    }

    .participant-info,
    .participant-outreach,
    .address-details,
    .sponsoring-employer-details,
    .intake-selection-details {
      padding: 0px 0px 24px 16px;

      ${responsive.MOBILE`
          padding: 0px 8px 16px 8px;
      `}

      .occupational-level-other,
      .occupational-function-other {
        white-space: nowrap;
        .title {
          .mui-label {
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }

      .MuiGrid2-container {
        padding: 0px;
        margin-top: 0;
      }
    }
    .about-participant {
      padding: 16px 0px 24px 16px;
    }
    .about-textfield {
      width: 60%;
    }
    .participant-outreach,
    .sponsoring-employer-details,
    .intake-selection-details {
      .section-grid-container {
        ${responsive.TABLET_PORTRAIT`
          margin-top: 0;
        `}
        ${responsive.MOBILE`
          margin-top: 8px;
        `}
      }
    }

    .activity-timeline {
      padding-top: 16px;

      .MuiGrid2-container {
        padding: 0px;
        margin-top: 0;
      }

      .filter-wrapper {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: flex-start;
        padding: 16px;
        padding-right: 0;
        border-bottom: 1px solid ${COLORS.cirrus_black4};

        ${responsive.MOBILE`
          padding: 16px 8px;
        `}

        .modality {
          ${responsive.MOBILE`
            width: 100%;

            .mui-select {
              width: 100%;
            }
          `}
        }

        .add-activity-wrapper {
          margin-left: auto; /* Align this to the right */
          margin-right: 24px;

          ${responsive.MOBILE`
            width: 100%;

            .btn-secondary {
              width: 100%;
            }
          `}
        }

        ${responsive.TABLET_PORTRAIT`
          flex-direction: column; 
          align-items: flex-start; 
          .modality {
            margin-left: 0;
            margin-top: 10px;
          }
          .add-activity-wrapper {
            margin-left: 0;
            margin-top: 16px;
          }
        `}
      }

      .next-contact-date-wrapper {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: flex-start;
        padding-bottom: 16px;
        padding-left: 16px;
        border-bottom: 1px solid ${COLORS.cirrus_black4};

        ${responsive.TABLET_PORTRAIT`
          flex-direction: column; 
          align-items: flex-start; 
        `}

        ${responsive.MOBILE`
          padding-right: 8px;
          padding-left: 8px;
        `}

        .MuiPickersTextField-root,
        .MuiPickersInputBase-root {
          /* width: 100% !important; */
        }
      }

      .duration-picker-wrapper {
        background: ${COLORS.cirrus_black2};
        padding: 16px;

        .go-btn-grid {
          display: flex;

          ${responsive.MOBILE`
            margin-top: 8px;
          `}

          .MuiButtonBase-root {
            margin-top: auto;
          }
        }
      }
    }
  }

  .status-header {
    display: flex;
    justify-content: space-between;
    .MuiButton-textPrimary {
      height: 40px;
      margin-right: 16px;
    }
  }
  .currency-container {
    width: 60%;
    .mui-label {
      white-space: nowrap;
    }
  }
  .currency-range-container {
    width: 50%;
    margin-top: 33px;
    ${responsive.MOBILE`
      margin-top: 28px;
    `}
  }
  .currency-container-main {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
  }
  .currency-container-textfield {
    width: calc(100% - 132px);
  }
  .select-preference-container {
    border-top: 1px dashed ${COLORS.primary_light_blue};
  }
  .select-preference-authorized {
    display: flex;
    align-items: baseline;
  }
  .divider-container {
    border: 3px solid ${COLORS.cirrus_black2};
    margin: 16px;
    border-radius: 4px;
  }

  .career-goal-label-style {
    margin: 34px 16px 0 16px;
    font-size: 20px;
    color: ${COLORS.cirrus_black10};

    ${responsive.MOBILE`
      margin: 16px 16px 0 16px;
    `}
  }
  .sub-label-style {
    margin-top: 32px;
    color: ${COLORS.cirrus_black7};
  }
  .checkbox-container-career-goal {
    margin: 0 16px 24px 16px;
    color: ${COLORS.primary_light_blue1};

    ${responsive.MOBILE`
      margin: 0 8px 16px 8px;
    `}
  }
  .dash-separator-full-width {
    margin: 24px 16px 0px 0px;
    border-top: 1px dashed ${COLORS.primary_light_blue};
  }

  .content {
    padding: 0px 16px 24px 16px;
    width: 100%;
    ${responsive.MOBILE`
        padding: 0px 16px 16px 8px;
      `}

    .section-grid-container {
      margin-top: 24px !important;

      ${responsive.MOBILE`
          margin-top: 8px !important;
        `}
    }
  }
`;

export const AddActivityWrapper = styled.div`
  padding: 24px 0px;

  ${responsive.MOBILE`
    padding: 0;
  `}

  .MuiGrid2-root {
    padding-right: 18px;
    margin-top: 40px;
    &:nth-child(-n + 3) {
      margin-top: 0px;
    }

    ${responsive.TABLET_LANDSCAPE`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 0px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
      &:nth-child(-n + 2) {
      margin-top: 0px;
    }
    `}
    ${responsive.MOBILE`
      padding-right: 16px;
      &:nth-child(1) {
        margin-top: 0px;
      }
      &:nth-child(n+2) {
        margin-top: 16px;
        }
    `}
  }

  .MuiGrid2-container {
    padding-right: 0px;
  }

  .activity-form-container {
    padding: 0px 0px 0px 16px;

    ${responsive.MOBILE`
      padding: 16px 0 16px 16px;
    `}
  }
  .padding-bottom {
    padding-bottom: 24px;

    ${responsive.MOBILE`
      padding-bottom: 16px;
    `}
  }
  .padding-top {
    padding-top: 24px;

    ${responsive.MOBILE`
      padding-top: 16px;
    `}
  }
  .participant-container {
    padding-left: 16px;

    ${responsive.MOBILE`
      padding-bottom: 16px;
    `}
  }

  .dash-separator {
    border-top: 1px dashed ${COLORS.primary_light_blue};
  }
`;
